<nb-card class="dashboard-permission">
  <nb-card-header class="d-flex">
    <nb-icon (click)="closeDialog()" icon="close-outline"></nb-icon>
    دسترسی‌های نمودار "<div [innerHtml]="sanitizedString"></div>"
  </nb-card-header>
  <nb-card-body class="dashboard-permission-body" *ngIf="!loading">
    <div class="permission-info">
      <div class="body-alert">
        <morva-icons class="active-icon icon-18 ms-1" icon="info"></morva-icons>
        <div>
          مجوزهای اعطاشده به گروه کاربری براساس نقش هرکاربر تعیین خواهد شد.
        </div>
      </div>
      <a class="guidance" [href]="helpURL">
        <morva-icons icon="helpCircle" class="active-icon icon-16 ms-1"></morva-icons>
        راهنما
      </a>
    </div>

    <div class="dashboard-permission-table table-special">
      <!-- table header -->
      <div class="header">
        <div class="col-3">کاربر/گروه کاربری</div>
        <div class="col-2 default-access">تمپلیت دسترسی</div>
        <div class="header-icons col-7">
          <morva-icons nbTooltip="مشاهده" icon="eye" class="m-icon-1"></morva-icons>
          <morva-icons nbTooltip="ویرایش" icon="pencil" class="m-icon-1"></morva-icons>
          <morva-icons nbTooltip="فیلتر کاربری" icon="userFilter" class="m-icon-1"></morva-icons>
          <morva-icons nbTooltip="خروجی" icon="downloadData" class="m-icon-1"></morva-icons>
          <morva-icons nbTooltip="مجوزها" icon="shield" class="m-icon-1"></morva-icons>
          <morva-icons nbTooltip="حذف" icon="trash" class="m-icon-1"></morva-icons>
        </div>
      </div>
      <hr />

      <!-- table-row -->
      <div *ngFor="let user of users; let userIndex = index">
        <div class="permission-row" >
          <div class="row-title col-3 d-flex align-items-center">
            <morva-icons class="icon-18" icon="person"></morva-icons>
            <span class="me-2" [ngClass]="{'disable-item': isUserDisabled(user)}">
              {{ user?.firstName || user?.groupName }} {{ user?.lastName }}
            </span>
          </div>
          <div class="permission-container-dropdown col-2" [ngClass]="{'disable-item': isUserDisabled(user)}">
            <ng-select appendTo="body" class="permission-dropdown"
              [searchable]="false"
              [size]="'tiny'"
              [ngModel]="user?.isRole ? (user?.roleId) : 'سفارشی'"
              (change)="changeRole($event, userIndex)"
              [disabled]="isUserDisabled(user)">
              <ng-option *ngFor="let role of defaultRoles" [value]="role?.id">
                {{ role?.name }}
              </ng-option>
            </ng-select>
          </div>
          <div class="row-checkboxs col-5">
            <nb-checkbox class="m-icon-2"
                         [checked]="user?.permissionsSelected?.get('View')?.isChecked  && !user?.permissionsBlocked?.get('View')?.isChecked"
                         [disabled]="isUserDisabled(user) ||user?.permissionsBlocked?.get('View')?.isChecked"
                         (checkedChange)="changePermission($event,'View',userIndex)"
            ></nb-checkbox>
            <nb-checkbox class="m-icon-2"
                         [checked]="user?.permissionsSelected?.get('Edit')?.isChecked  && !user?.permissionsBlocked?.get('Edit')?.isChecked"
                         [disabled]="isUserDisabled(user) ||user?.permissionsBlocked?.get('Edit')?.isChecked"
                         (checkedChange)="changePermission($event,'Edit',userIndex)"
            ></nb-checkbox>
            <nb-checkbox class="m-icon-2"
                         [checked]="user?.permissionsSelected?.get('UserFilter')?.isChecked  && !user?.permissionsBlocked?.get('UserFilter')?.isChecked"
                         [disabled]="isUserDisabled(user) ||user?.permissionsBlocked?.get('UserFilter')?.isChecked"
                         (checkedChange)="changePermission($event,'UserFilter',userIndex)"
            ></nb-checkbox>
            <nb-checkbox class="m-icon-2"
                         [checked]="user?.permissionsSelected?.get('Export')?.isChecked  && !user?.permissionsBlocked?.get('Export')?.isChecked"
                         [disabled]="isUserDisabled(user) ||user?.permissionsBlocked?.get('Export')?.isChecked"
                         (checkedChange)="changePermission($event,'Export',userIndex)"
            ></nb-checkbox>
            <nb-checkbox class="m-icon-2"
                         [checked]="user?.permissionsSelected?.get('Permissions')?.isChecked  && !user?.permissionsBlocked?.get('Permissions')?.isChecked"
                         [disabled]="isUserDisabled(user) ||user?.permissionsBlocked?.get('Permissions')?.isChecked"
                         (checkedChange)="changePermission($event,'Permissions',userIndex)"
            ></nb-checkbox>
            <nb-checkbox class="m-icon-2"
                         [checked]="user?.permissionsSelected?.get('Remove')?.isChecked  && !user?.permissionsBlocked?.get('Remove')?.isChecked"
                         [disabled]="isUserDisabled(user) ||user?.permissionsBlocked?.get('Remove')?.isChecked"
                         (checkedChange)="changePermission($event,'Remove',userIndex)"
            ></nb-checkbox>
          </div>
          <div class="cposition-absolute l-0 col-2 d-flex justify-content-end align-items-center">
            <!-- <nb-icon
              [matMenuTriggerFor]="menu"
              (click)="$event.stopPropagation()"
              class="more"
              icon="more-horizontal-outline">
            </nb-icon>

            <mat-menu class="menu-chart mat-elevation-z4" #menu="matMenu">
              <button mat-menu-item (click)="openDeleteDialog(user)">حذف</button>
            </mat-menu> -->
          </div>
        </div>
        <hr />
      </div>
    </div>
    <morva-pagination *ngIf="totalPage > 1" [totalPage]="totalPage"
                      [selectedPage]="pageNumber" (pageChange)="changePageNumber($event)"></morva-pagination>
    <div class="permisson-button">
      <button
        class="cancel-button ms-3"
        nbButton
        size="large"
        (click)="closeDialog()"
      >
        بستن
      </button>

    </div>
  </nb-card-body>
  <nb-card-body class="dashboard-permission-body" *ngIf="loading">
    <div class="dashboard-permission-table table-special">
      <div class="permission-row pb-3">
        <div class="col-3">
          <ngx-skeleton-loader class="w-100" appearance="line" [theme]="{width: '132px', height: '20px', 'margin-bottom': 0, 'margin-top': '7px', 'background-color':'#EFEFEF'}"></ngx-skeleton-loader>
        </div>
        <div class="col-9">
          <ngx-skeleton-loader class="w-100" appearance="line" [theme]="{width: '630px', height: '20px', 'margin-bottom': 0, 'margin-top': '7px', 'background-color':'#EFEFEF'}"></ngx-skeleton-loader>
        </div>
      </div>
      <div class="permission-row">
        <div class="col-3">
          <ngx-skeleton-loader class="w-100" appearance="line" [theme]="{width: '132px', height: '20px', 'margin-bottom': 0, 'margin-top': '7px', 'background-color':'#EFEFEF'}"></ngx-skeleton-loader>
        </div>
        <div class="col-9">
          <ngx-skeleton-loader class="w-100" appearance="line" [theme]="{width: '630px', height: '20px', 'margin-bottom': 0, 'margin-top': '7px', 'background-color':'#EFEFEF'}"></ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </nb-card-body>
</nb-card>
